import { StyledDialogPanel, lightTheme } from "@quickpoint.me/shared";
import { type MutableSnapshot, RecoilRoot } from "recoil";
import styled, { ThemeProvider } from "styled-components";

import FilesView from "./displayComponents/files/FilesView";
import MessageHandler from "./functionalComponents/MessageHandler";
import { HostId } from "./state/uploaderState";

const StyledFileUploader = styled.div`
    height: 100%;
`;

function FileUploader({
	show,
	isInPortrait,
	hostId,
}: { show: boolean; isInPortrait: boolean; hostId: string }) {
	// if the browser doesn't support Broadcast Channels disable
	// the ability of the viewer to receive messages from the author.
	try {
		BroadcastChannel;
	} catch {
		return <div>BroadcastChannel is required</div>;
	}

	const initializeState = ({ set }: { set: MutableSnapshot["set"] }) => {
		set(HostId, hostId);
	};
	return (
		<ThemeProvider theme={lightTheme}>
			<StyledDialogPanel
				id="file-uploader"
				$show={show}
				$isInPortrait={isInPortrait}
				className="file-drop-zone styled-dialog-panel"
			>
				<RecoilRoot initializeState={initializeState}>
					<MessageHandler />
					<StyledFileUploader>
						<FilesView $isInPortrait={isInPortrait} />
					</StyledFileUploader>
				</RecoilRoot>
			</StyledDialogPanel>
		</ThemeProvider>
	);
}

export default FileUploader;
